var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMineCardsLogoPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 48C28 36.9543 36.9543 28 48 28H60C71.0457 28 80 36.9543 80 48V60C80 71.0457 71.0457 80 60 80H48C36.9543 80 28 71.0457 28 60V48Z",
    fill: "#1F1F23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8698 22.5416L47.6875 20.4579C58.0215 18.6357 67.876 25.5359 69.6982 35.8699L71.7819 47.6876C73.6041 58.0216 66.7039 67.8761 56.3699 69.6982L44.5522 71.782C34.2182 73.6042 24.3637 66.704 22.5415 56.37L20.4578 44.5523C18.6356 34.2183 25.5358 24.3638 35.8698 22.5416Z",
    fill: "#FFCB11",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0175 35.2119L48.5606 41.4031L56.239 41.1773L51.7528 47.408L54.3452 54.6356L47.0297 52.2954L40.9558 56.9965L40.9199 49.3181L34.5732 44.9976L41.8658 42.5836L44.0175 35.2119Z",
    stroke: "#1F1F23",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMineCardsLogoPremium);
export default __webpack_public_path__ + "static/media/MineCards-Logo-Premium.a283153f5f0233f3fe2d09e1aa965e3e.svg";
export { ForwardRef as ReactComponent };